import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import authReducer from '../modules/auth/store/authSlice';
import usersReducer from '../modules/users/store/usersSlice';
import notificationReducer from '../modules/notification/store/notificationSlice';
import znsTemplateReducer from '../modules/outbound-message/store/znsTemplateSlice';
import znsCampaignReducer from '../modules/outbound-message/store/znsCampaignSlice';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    notification: notificationReducer,
    znsTemplate: znsTemplateReducer,
    znsCampaign: znsCampaignReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga)

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
